module.exports = __webpack_public_path__ + "img/nav-cara.1ee2f424.svg";